import React from 'react';
import Layout from '../Components/Layout';
import { Link } from 'react-router-dom';
import know_1 from '../Assets/images/know1.png'
import know_2 from '../Assets/images/know2.png'
import know_3 from '../Assets/images/know3.png'
import know_banner from '../Assets/images/konw_banner.png'




function Knowmore(props) {
    return (
        <Layout>
            <section className='bg-[#FFFCEF] common-space-both'>
                <div className='container'>
                    <div className='grid grid-cols-2 gap-3 place-items-center mobile:grid-cols-1'>
                        <div className='common-title '>
                            <label className='bg-white p-3 inline-block mb-5 text-black rounded-lg'>Lorem ipsum is simple</label>
                            <h1 className='text-black'>Let Your Advertisement Of  <span> Pay You Back</span> 💸📈 </h1>
                            <p className='mt-4'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                            <Link to={''} className='btn-common'>Contact us</Link>
                        </div>
                        <div>
                            <img src={know_banner} />
                        </div>
                    </div>
                </div>

            </section>
            <section className='container common-space'>
                <div className='grid grid-cols-2 mt-4 gap-5 tablet:grid-cols-1 place-items-center'>
                    <div className='common-title'>
                        <h2 className='after:hidden !mb-2'>Lorem Ipsum is simply dummy text</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type.</p>
                        <Link to={''} className='btn-common'>Know More</Link>
                    </div>
                    <div>
                        <img src={know_1} className='img-fluid' />
                    </div>
                </div>
            </section>
            <section className='container common-space'>
                <div className='grid grid-cols-2 mt-4 gap-5 tablet:grid-cols-1 place-items-center'>
                    <div>
                        <img src={know_2} className='img-fluid' />
                    </div>
                    <div className='common-title'>
                        <h2 className='after:hidden !mb-2'>Reach Your Customers</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type.</p>
                        <Link to={''} className='btn-common'>Contact us</Link>
                    </div>

                </div>
            </section>
            <section className='container common-space-both'>
                <div className='grid grid-cols-2 mt-4 gap-5 tablet:grid-cols-1 place-items-center'>
                    <div className='common-title'>
                        <h2 className='after:hidden !mb-2'>Grow Your Company</h2>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type.</p>
                        <Link to={''} className='btn-common'>Know More</Link>
                    </div>
                    <div>
                        <img src={know_3} className='img-fluid' />
                    </div>
                </div>
            </section>
        </Layout>
    );
}

export default Knowmore;